<div class="login-page">
  <section class="login-panel">
    <div class="login-card">
      <div class="card-head">
        <img class="card-logo" src="assets/weekly-plan/school-logo.png" alt="School logo" />
        <h2>{{ 'LOGIN.WELCOME' | translate }}</h2>
        <p>{{ 'LOGIN.SUBTITLE' | translate }}</p>
      </div>

      <button type="button" class="lang-switch" (click)="toggleLanguage()">
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>
          <path d="M3.2 9.5h17.6M3.2 14.5h17.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          <path d="M12 3c2.4 2.4 3.6 5.4 3.6 9s-1.2 6.6-3.6 9c-2.4-2.4-3.6-5.4-3.6-9S9.6 5.4 12 3Z" stroke="currentColor" stroke-width="1.6"/>
        </svg>
        {{ 'HEADER.LANGUAGE' | translate }}
      </button>

      <form class="login-form" (ngSubmit)="onSubmit(usernameInput.value, passwordInput.value)">
        <div class="field">
          <label for="username">{{ 'LOGIN.USERNAME' | translate }}</label>
          <div class="input-wrap">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="8" r="3.4" stroke="currentColor" stroke-width="1.6"/>
                <path d="M4.8 19.2c1.3-3.2 4-4.8 7.2-4.8s5.9 1.6 7.2 4.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
              </svg>
            </span>
            <input
              #usernameInput
              id="username"
              type="text"
              name="username"
              autocomplete="username"
              [placeholder]="'LOGIN.USERNAME_PLACEHOLDER' | translate"
              required
              (input)="clearError()"
            />
          </div>
        </div>

        <div class="field">
          <label for="password">{{ 'LOGIN.PASSWORD' | translate }}</label>
          <div class="input-wrap">
            <span class="input-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <rect x="4.5" y="10.5" width="15" height="9" rx="2.2" stroke="currentColor" stroke-width="1.6"/>
                <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
              </svg>
            </span>
            <input
              #passwordInput
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              name="password"
              autocomplete="current-password"
              [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
              required
              (input)="clearError()"
            />
            <button
              type="button"
              class="eye-btn"
              (click)="togglePassword()"
              [attr.aria-label]="(showPassword ? 'LOGIN.HIDE_PASSWORD' : 'LOGIN.SHOW_PASSWORD') | translate"
            >
              <svg *ngIf="!showPassword" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M2.5 12C4.8 7.8 8.2 5.5 12 5.5s7.2 2.3 9.5 6.5c-2.3 4.2-5.7 6.5-9.5 6.5S4.8 16.2 2.5 12Z" stroke="currentColor" stroke-width="1.6"/>
                <circle cx="12" cy="12" r="2.5" stroke="currentColor" stroke-width="1.6"/>
              </svg>
              <svg *ngIf="showPassword" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M3 3l18 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                <path d="M6.5 6.8C4.4 8.5 2.9 10.8 2.5 12c2.3 4.2 5.7 6.5 9.5 6.5 1.8 0 3.5-.5 5-1.4M10.7 10.7a2.5 2.5 0 0 0 3.2 2.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                <path d="M14.1 5.9A9.6 9.6 0 0 0 12 5.5c-3.8 0-7.2 2.3-9.5 6.5.8 1.5 1.9 2.8 3.2 3.9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        <p *ngIf="loginError" class="error-message" role="alert">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"/>
            <path d="M12 7.5v5.2M12 16.2h.01" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
          {{ errorMessage | translate }}
        </p>

        <button type="submit" class="submit-btn" [disabled]="loading">
          <span *ngIf="loading" class="spinner" aria-hidden="true"></span>
          {{ (loading ? 'LOGIN.SIGNING_IN' : 'LOGIN.SIGN_IN') | translate }}
        </button>
      </form>

      <p class="card-foot">{{ 'LOGIN.HELP' | translate }}</p>
    </div>
  </section>

  <aside class="login-visual">
    <img class="login-bg" src="assets/img/panner.jpeg" alt="" aria-hidden="true" />
    <div class="login-visual-shade" aria-hidden="true"></div>

    <div class="login-brand">
      <img class="brand-logo" src="assets/weekly-plan/school-logo.png" alt="School logo" />
      <h1 class="brand-title">{{ 'LOGIN.SCHOOL_NAME' | translate }}</h1>
    </div>
  </aside>
</div>
